<header class="flex header">
  <h2>{{ shipment?.shipmentNumber }}</h2>
</header>
<section class="content">
  <div class="form-box">
    <label for="">{{ 'Shipment_Modal_ID' | translateWF: 'ID' }}</label>
    <input type="text" pInputText [disabled]="true" [value]="shipment?.shipmentNumber" />
  </div>
  <div class="form-box">
    <label for="">{{ 'Shipment_Modal_State_Arrival' | translateWF: 'State Arrival' }}</label>
    <p-datePicker [formControl]="estimatedArrivalDate" />
  </div>

  <div class="form-box">
    <label for="">{{ 'Shipment_Details_Tracking' | translateWF: 'Tracking' }}</label>
    <input type="text" pInputText [disabled]="true" [value]="shipment?.trackingNumber" />
  </div>
  <div class="form-box">
    <label for="">{{ 'Shipment_Modal_Create_Date' | translateWF: 'Create Date' }}</label>
    <p-datePicker [formControl]="createDate" />
  </div>

  <section>
    <h4 class="line">{{ 'Purchase_Order_Details_Invoices' | translateWF: 'Invoices' }}</h4>

    <p-scrollpanel [style]="{ width: '100%', height: '250px' }">
      <ul class="invoices">
        @for (item of shipmentInvoices; track $index) {
          <li class="invoice">
            {{ item.invoiceNumber }}
          </li>
        } @empty {
          <li class="invoice">{{ 'Shipment_Modal_No_Invoices_Included' | translateWF: 'No Invoices included' }}</li>
        }
      </ul>
    </p-scrollpanel>
  </section>
</section>
<footer>
  <p-button class="w-full" [label]="'Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
</footer>
